import { render } from "./ProjectPreview.vue?vue&type=template&id=361627d8&scoped=true&ts=true"
import script from "./ProjectPreview.vue?vue&type=script&lang=ts"
export * from "./ProjectPreview.vue?vue&type=script&lang=ts"

import "./ProjectPreview.vue?vue&type=style&index=0&id=361627d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361627d8"]])

export default __exports__